/**
 * HTML descriptions store relative img paths like:
 *   /assets/imgs/...  → Front website (simsystemes.tn)
 *   /images/...       → API / Laravel public (api.simsystemes.com)
 * Dashboard origin has neither, so rewrite before dangerouslySetInnerHTML.
 */
export const getApiOrigin = () =>
  (process.env.REACT_APP_API_BASE_URL || "").replace(/\/api\/?$/, "");

export const getFrontOrigin = () =>
  process.env.REACT_APP_FRONT_URL ||
  process.env.REACT_APP_PUBLIC_SITE_URL ||
  "https://www.simsystemes.tn";

export const rewriteHtmlImageUrls = (html) => {
  if (html == null || html === "null" || html === "undefined") return "";
  if (typeof html !== "string") return "";
  if (!html.trim()) return "";

  const apiOrigin = getApiOrigin();
  const frontOrigin = getFrontOrigin().replace(/\/$/, "");

  return html.replace(
    /(<img\b[^>]*?\bsrc\s*=\s*["'])([^"']+)(["'])/gi,
    (match, pre, src, post) => {
      if (/^(https?:|data:|blob:)/i.test(src)) {
        return match;
      }
      const path = src.startsWith("/") ? src : `/${src}`;

      if (
        path.startsWith("/images/") ||
        path.startsWith("/storage/") ||
        path.startsWith("/assets/resumes/") ||
        path.startsWith("/assets/pdf/")
      ) {
        return `${pre}${apiOrigin}${path}${post}`;
      }

      if (path.startsWith("/assets/")) {
        return `${pre}${frontOrigin}${path}${post}`;
      }

      return apiOrigin ? `${pre}${apiOrigin}${path}${post}` : match;
    }
  );
};

/** Keep relative img paths in DB when saving from Quill (after rewrite for display). */
export const stripAbsoluteImageOrigins = (html) => {
  if (!html || typeof html !== "string") return html || "";

  const origins = [getFrontOrigin(), getApiOrigin()]
    .filter(Boolean)
    .map((o) => o.replace(/\/$/, ""));

  return html.replace(
    /(<img\b[^>]*?\bsrc\s*=\s*["'])([^"']+)(["'])/gi,
    (match, pre, src, post) => {
      for (const origin of origins) {
        if (src.startsWith(`${origin}/`)) {
          return `${pre}${src.slice(origin.length)}${post}`;
        }
      }
      return match;
    }
  );
};

export default rewriteHtmlImageUrls;
